import { createSelector } from '@ngrx/store';
import { ActiveTenantStore } from '@arc/arc-shared-frontend';

export const selectTenantName = createSelector(
  ActiveTenantStore,
  (tenant) => tenant?.tenantName,
);

export const selectTenantId = createSelector(
  ActiveTenantStore,
  (tenant) => tenant?.tenantId,
);
